<div class="containerPanel-CC mx-auto mt-6">
  <div class="containerText-CC pt-24 px-14">
    <p class="title-CC text-center mt-3">
      {{ resource.confirmEndorsement.title }}
    </p>
    <p class="subtitle-CC mt-3">{{ resource.confirmEndorsement.subtitle }}</p>
  </div>
  <div class="containerTextSB-CC text-left mt-3 mx-4">
    <p class="text-center">
      {{ resource.confirmEndorsement.text1 }}
    </p>
  </div>
</div>
